var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { createReactTooltip } from '../../common/tooltip';
import classNames from 'classnames';
import { getVersionBrowserColoringClass } from '../../versionBrowser/utils';
import AccurityDatePicker from './AccurityDatePicker';
import AccurityIcon from '../../icon/components/AccurityIcon';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
import { Stack } from '@mui/material';
var DateField = function (_a) {
    var name = _a.name, label = _a.label, className = _a.className, onChange = _a.onChange, value = _a.value, errorMessage = _a.errorMessage, disabled = _a.disabled, coloring = _a.coloring, tooltip = _a.tooltip, inherited = _a.inherited;
    var _b = createReactTooltip(tooltip, 'dateField' + name), tooltipAnchorParams = _b.tooltipAnchorParams, tooltipElement = _b.tooltipElement;
    var _c = useState(false), isPickerOpen = _c[0], setIsPickerOpen = _c[1];
    var openPicker = function () {
        setIsPickerOpen(true);
    };
    var onPickerClose = function () {
        setIsPickerOpen(false);
    };
    return (React.createElement("div", __assign({ className: classNames('dateField', className, getVersionBrowserColoringClass(coloring)) }, tooltipAnchorParams),
        tooltipElement,
        React.createElement(Stack, { position: "absolute", right: "0", direction: "row", sx: { zIndex: 3 } }, inherited && React.createElement(AccurityIcon, { iconName: "mui:LayersOutlined", fontSize: "small", color: "secondary700" })),
        React.createElement("div", { className: 'dateField__openButton' },
            React.createElement(AccurityIconButton, { onClick: openPicker, iconName: "mui:Event", title: "Pick date" })),
        React.createElement(AccurityDatePicker, { label: label, value: value, onChange: onChange, isPickerOpen: isPickerOpen, onPickerClose: onPickerClose, hideNativePickerButton: true, disabled: disabled, errorMessage: errorMessage })));
};
export default DateField;
//# sourceMappingURL=DateField.js.map